import { UnderHeader } from 'components/atoms/SectionWrapper.style';
import React from 'react';
import styled from 'styled-components';
import { HeadlineOne, Paragraph } from 'components/atoms/SectionWrapper.style';
import { cms } from 'assets/cms';

const EleFarmImg = styled.div`
  background: center center url(${cms.electro.electrocar});
  background-size: cover;
  height: 250px;
  background-repeat: no-repeat;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media ${({ theme }) => theme.media.tablet} {
    height: 400px;
  }
  padding: 35px;
`;

const Par = styled.div`
  font-size: 8px;
  right: 0;
`;

const EleOfferImages = () => (
  <>
    <UnderHeader />
    <EleFarmImg>
      {/* <Paragraph>Receco</Paragraph> */}
      {/* <HeadlineOne>Oferta</HeadlineOne> */}
    </EleFarmImg>
    {/* <Par>
      <a href="https://www.freepik.com/free-photo/charging-power-electric-vehicle-ev-carelectric-car-charging-station3d-rendering_25818131.htm#query=electromobility&position=3&from_view=keyword">
        Image by vanitjan
      </a>
      on Freepik
    </Par> */}
  </>
);

export default EleOfferImages;
